var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffice = function SvgOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 10a1 1 0 0 1 1-1h30a1 1 0 1 1 0 2h-.667v20.667a1 1 0 1 1-2 0v-4h-4A4.334 4.334 0 0 1 24 23.333v-5.666H7.667v14a1 1 0 1 1-2 0V11H5a1 1 0 0 1-1-1m22 7.667v5.666a2.333 2.333 0 0 0 2.333 2.334h4v-8zm0-2V11h6.333v4.667zM24 11v4.667H7.667V11z",
    clipRule: "evenodd"
  })));
};
export default SvgOffice;